import React, { useState } from "react";
import moment from "moment";
import { WIDGET_NAMES } from "../../Dashboard.consts";
import { WidgetBox } from "../../boxes/WidgetBox/WidgetBox";
import { API_DATE_FORMAT } from "../../../../consts/api.js";
import { useAppointmentEngagement } from "./hooks/useAppointmentEngagement";
import AppointmentEngagementChart from "./components/AppointmentEngagementChart";
import { ClinicsSelect } from "./components/ClinicsSelect.js";

export function WidgetAppointmentEngagement() {
  const [dates, setDates] = useState({
    start: moment().startOf("week").toDate(),
    end: moment().endOf("week").toDate(),
  });

  const [clinicId, setClinicId] = useState(0);

  const onSelectDateRange = (result) => {
    setDates({
      start: result.startDate,
      end: result.endDate,
      startRaw: result.startDateRaw,
      endRaw: result.endDateRaw,
    });
  };

  const params = {
    from_date: moment(dates.start).format(API_DATE_FORMAT),
    to_date: moment(dates.end).format(API_DATE_FORMAT),
    ...(clinicId ? { clinic_id: clinicId } : {}),
  };

  const { data: widgetData, isLoading: isWidgetDataLoading } =
    useAppointmentEngagement(params, {
      select: (resp) => {
        // Normalize response to { data: [], columns: [] }
        const root = resp && resp.data ? resp.data : resp;
        const inner = root && root.data ? root.data : root;
        if (inner && inner.data && inner.columns) {
          return inner;
        }
        // If an array is returned directly, wrap it and infer columns by keys
        if (Array.isArray(inner)) {
          const first = inner[0] || {};
          const columns = Object.keys(first);
          return { data: inner, columns };
        }
        return { data: [], columns: [] };
      },
      enabled: Boolean(params.from_date),
    });

  const items = widgetData && widgetData.data ? widgetData.data : [];
  const columns = widgetData && widgetData.columns ? widgetData.columns : [];

  return (
    <WidgetBox
      label={WIDGET_NAMES.appointment_engagement}
      isLoading={isWidgetDataLoading}
      isEmpty={(items && items.length) === 0}
      headerClassName="flex justify-between items-center"
      dateRange={{
        dates,
        onSelect: onSelectDateRange,
      }}
      footerFilters={
        <div className="flex items-center gap-8 p-10">
          <div style={{ minWidth: 200 }}>
            <ClinicsSelect value={clinicId} onSelect={setClinicId} />
          </div>
        </div>
      }
    >
      <AppointmentEngagementChart items={items} columns={columns} />
    </WidgetBox>
  );
}
